import { Height, Search } from "@mui/icons-material";
import { LatLngTuple, Map } from "leaflet";
import L from "leaflet";

import React, { FormEventHandler, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { MapContainer, Marker, Popup, TileLayer, useMapEvents } from "react-leaflet";

import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import { Box, Button, Grid, IconButton, Table, TableBody, TableCell, TableRow, TextField } from "@mui/material";
import { IAddress } from "../../interfaces/IAddress";
import { IPostcode } from "../../interfaces/IPostcode";
import { getFetch, useFetch } from "../../hooks/useFetch";

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
});

L.Marker.prototype.options.icon = DefaultIcon;

const center = {
    lat: 52.7597,
    lng: 13.25391,
};

interface IPropsDraggaleMarker {
    postition: { lat: number; lng: number };
    setPostition: Function;

    setStreet: Function;
    setStreetNr: Function;
    setPostcode: Function;
    city: string;
    setCity: Function;
    setLat: Function;
    setLong: Function;
    setPostcodeObject: Function;
}

interface IPropsMapSearch {
    currentAddress: IAddress | undefined;
}

const DraggableMarker: React.FC<IPropsDraggaleMarker> = (props) => {
    const [draggable, setDraggable] = useState(true);
    const markerRef = useRef<any | null>(null);
    //
    const [postcode, setPostcode] = useState("");

    const map = useMapEvents({
        click: (e) => {
            props.setPostition({ lat: e.latlng.lat, lng: e.latlng.lng });
        },
    });

    useEffect(() => {
        props.setLat(props.postition.lat);
        props.setLong(props.postition.lng);

        fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${props.postition.lat}&lon=${props.postition.lng}&format=json`,
            {
                headers: {
                    "User-Agent": "DiNoPublic",
                },
            },
        )
            .then((res) => res.json())
            .then((res) => {
                props.setStreet(res.address.road);
                props.setStreetNr(res.address.house_number);
                props.setPostcode(res.address.postcode);
                setPostcode(res.address.postcode);
                "town" in res.address ? props.setCity(res.address.town) : props.setCity(res.address.city);
            });
    }, [props.postition]);

    const getHandler = (localPostcodeArray: IPostcode[]) => {
        let testObject = localPostcodeArray.find((x) => x.city.toLocaleLowerCase() === props.city.toLocaleLowerCase());

        if (testObject !== undefined) {
            props.setPostcodeObject(testObject);
        } else if (localPostcodeArray.length > 0) {
            props.setPostcodeObject(localPostcodeArray[0]);
        }
    };

    useEffect(() => {
        if (postcode !== "" && props.city !== "") {
            getFetch(`/postcode/`, postcode, getHandler);
        }
    }, [postcode, props.city]);

    const eventHandlers = useMemo(
        () => ({
            dragend() {
                const marker = markerRef.current;
                if (marker != null) {
                    props.setPostition(marker.getLatLng()!);
                }
            },
        }),
        [],
    );
    const toggleDraggable = useCallback(() => {
        setDraggable((d) => !d);
    }, []);

    return (
        <Marker draggable={draggable} eventHandlers={eventHandlers} position={props.postition} ref={markerRef}>
            <Popup minWidth={90}>
                <>Sie können den Markierer auf die gewünschte Fläche bewegen</>
            </Popup>
        </Marker>
    );
};

export const MapSearch: React.FC<IPropsMapSearch> = (props) => {
    const [position, setPostition] = useState<{ lat: number; lng: number }>({
        lat: 52.7601123,
        lng: 13.024422,
    });

    const [street, setStreet] = useState("");
    const [streetNr, setStreetNr] = useState("");
    const [postcode, setPostcode] = useState("");
    const [city, setCity] = useState("");
    const [lat, setLat] = useState(0);
    const [long, setLong] = useState(0);
    //
    const [postcodeObject, setPostcodeObject, statusCodePostcode] = useFetch<IPostcode>(
        "/postcode/",
        props.currentAddress?.Postcode || 1,
    );
    //
    const [reload, setReload] = useState(0);

    const searchByText = (searchTerm: string) => {
        if (searchTerm !== "") {
            fetch(`https://nominatim.openstreetmap.org/search?q=${searchTerm}&format=json`, {
                headers: {
                    "User-Agent": "GW-Verwaltungssoftware",
                },
            })
                .then((res) => res.json())
                .then((res) => {
                    let localObject = res;

                    if (Array.isArray(res) && res.length > 0) {
                        localObject = res[0];
                    }

                    if ("lat" in localObject && "lon" in localObject) {
                        setPostition({ lat: localObject.lat, lng: localObject.lon });
                        setReload(reload + 1);
                    }
                });
        }
    };

    useEffect(() => {
        if (props.currentAddress !== undefined && postcodeObject !== undefined) {
            searchByText(
                `${props.currentAddress.street} ${props.currentAddress.street_number}, ${postcodeObject.postcode} ${postcodeObject.city}`,
            );
        }
    }, [props.currentAddress, postcodeObject]);

    return (
        <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
            <Grid item xs={12} sm={8}>
                <MapContainer
                    key={`MapContainer-${reload}`}
                    style={{ height: 250, width: 500, alignContent: "center", alignItems: "center" }}
                    center={position}
                    zoom={16}
                    scrollWheelZoom={false}
                >
                    <TileLayer
                        attribution='&copy;  GleichWerk | Karteninformationen &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <DraggableMarker
                        postition={position}
                        setPostition={setPostition}
                        setStreet={setStreet}
                        setStreetNr={setStreetNr}
                        setPostcode={setPostcode}
                        setCity={setCity}
                        city={city}
                        setLat={setLat}
                        setLong={setLong}
                        setPostcodeObject={setPostcodeObject}
                    />
                </MapContainer>
            </Grid>
        </Grid>
    );
};
